module.exports = __webpack_public_path__ + "171ec511645d8fb85e361e1b622ece35.svg";